import React from 'react';
import ModernAddButton from '@COMPONENTS/COMMON/buttons/ModernAddButton/ModernAddButton.component';
import classNames from 'classnames/bind';
import useNewSectionModal from '@HOOKS/store/modals/useNewSectionModal';
import styles from './AddSectionButton.module.scss';

const cx: CX = classNames.bind(styles);

function AddSectionButton(props: any) {
    const {
        locked, title, payload, className,
    } = props;
    const { actions: newSectionModalActions } = useNewSectionModal(() => true);

    return (
        <div className={cx('subsection-button-wrapper', className, 'custom-subsection-button-wrapper')}>
            <ModernAddButton
                title={title}
                size="small"
                variant="neutral"
                disabled={locked}
                onClick={(e) => {
                    e.stopPropagation();
                    newSectionModalActions.open({
                        documentId: payload.documentId,
                        chapterId: payload.chapterId,
                        parent: payload.parentId,
                        ...(payload.currentSection && { currentSection: payload.currentSection }),
                    });
                }}
            />
        </div>
    );
}

export default AddSectionButton;
